import DaumPostCose from 'react-daum-postcode';
import styled from 'styled-components';
import { DimmedBackground } from '../../../common/dimmed/DimmedBackground';
import { RegionHierarchy } from '../../../../store/userJoinSlice';

interface DaumPostCodeModalProps {
  isShow: boolean;
  onClose: () => void;
  onSearchFinished: (searchedRegion: string, regionHierarchy?: RegionHierarchy) => void;
  shouldReturnAddressHierarchy?: boolean;
  addressType?: 'roadname' | 'jibun' | 'both'; // 기본값: 'roadname'
}

export const DaumPostCodeModal = ({
  isShow,
  onClose,
  onSearchFinished,
  shouldReturnAddressHierarchy = false,
  addressType = 'roadname',
}: DaumPostCodeModalProps) => {
  const handleDaumPostCodeComplete = (data: any) => {
    // 주소 타입에 따라 반환할 주소 결정
    let selectedAddress = '';

    switch (addressType) {
      case 'jibun':
        selectedAddress = data.jibunAddress || data.autoJibunAddress || data.roadAddress;
        break;
      case 'both':
        selectedAddress = `${data.roadAddress} (지번: ${data.jibunAddress || data.autoJibunAddress})`;
        break;
      case 'roadname':
      default:
        selectedAddress = data.roadAddress;
        break;
    }

    if (shouldReturnAddressHierarchy) {
      onSearchFinished(selectedAddress, {
        regionDepth1: data.sido,
        regionDepth2: data.sigungu,
        regionDepth3: data.bname,
      });
    } else {
      onSearchFinished(selectedAddress);
    }
    onClose();
  };

  return (
    <DimmedBackground isShow={isShow} onClick={onClose}>
      <Container
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <DaumPostCose
          onComplete={handleDaumPostCodeComplete}
          autoClose={false}
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Container>
    </DimmedBackground>
  );
};

const Container = styled.div`
  width: 320px;
  height: 480px;

  position: absolute;

  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);

  border-radius: 8px;
  background-color: white;

  overflow: hidden;
`;
